import { NgModule } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { provideHttpClient } from '@angular/common/http';
import { ImagingRequestsColumnComponent } from './imaging-requests-column/imaging-requests-column.component';
import { ImagingRequestsTileComponent } from './imaging-requests-tile/imaging-requests-tile.component';
import { ImagingRequestsComponent } from './imaging-requests.component';
import { ImagingRequestsFiltersComponent } from './imaging-requests-filters/imaging-requests-filters.component';
import { ImagingRequestDetailsModalComponent } from './imaging-request-details/imaging-request-details-modal.component';
import { ImagingRequestOrdersDetailsComponent } from './imaging-request-details/imaging-request-orders-details/imaging-request-orders-details.component';
import { ImagingRequestOrderDetailsModalComponent } from './imaging-request-details/imaging-request-order-details-modal/imaging-request-order-details-modal.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from '@app/shared/shared.module';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { ImagingRequestFormComponent } from './imaging-request-form/imaging-request-form.component';
import { ScanRegionsFormComponent } from './imaging-request-form/scan-regions-form/scan-regions-form.component';
import { ScanRegionComponent } from './imaging-request-form/scan-regions-form/scan-region/scan-region.component';
import { DomSanitizer } from '@angular/platform-browser';
import { PatientSearchListComponent } from './imaging-request-form/patient-search-list/patient-search-list.component';

@NgModule({
    declarations: [
        ImagingRequestsComponent,
        ImagingRequestsColumnComponent,
        ImagingRequestsTileComponent,
        ImagingRequestsFiltersComponent,
        ImagingRequestDetailsModalComponent,
        ImagingRequestOrdersDetailsComponent,
        ImagingRequestOrderDetailsModalComponent,
        ImagingRequestFormComponent,
        ScanRegionsFormComponent,
        ScanRegionComponent,
        PatientSearchListComponent
    ],
    imports: [BrowserAnimationsModule, SharedModule],
    exports: [ImagingRequestsComponent],
    providers: [provideHttpClient()]
})
export class ImagingRequestsModule {
    constructor(library: FaIconLibrary, iconRegistry: MatIconRegistry, sanitiser: DomSanitizer) {
        library.addIcons(faInfoCircle);
        iconRegistry.addSvgIcon('white-cross', sanitiser.bypassSecurityTrustResourceUrl('assets/images/white-cross.svg'));
    }
}
